var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JbStandardNew',{attrs:{"biz-ctg":_vm.$config.BIZ_CATEGORY.ELEVATOR},on:{"link":_vm.handleLink}})
}
var staticRenderFns = []

export { render, staticRenderFns }